import React from 'react';
import { w as withProviders } from './withProviders-l3mjYkR2.js';
import { D as Drawer } from './Drawer-J1RjFs7M.js';
import QuickSearch from './components/QuickSearch/index.js';

const SearchDrawer = ({ isOpen, onClose }) => (React.createElement(Drawer, { open: isOpen, onClose: onClose, name: "search" },
    React.createElement(QuickSearch, { onSubmitCallback: onClose })));
var SearchDrawer$1 = withProviders(SearchDrawer, { translation: true });

export { SearchDrawer$1 as S };
//# sourceMappingURL=SearchDrawer-gwlJdq4F.js.map
